import React, { createContext, useContext, useState } from 'react'
import { toast } from 'react-toastify'
import { APIList } from '../../api/APIList'
import AxiosProvider from '../../api/AxiosProvider'
import { useAuth } from '../Auth/AuthProvider'
import axios from 'axios'

// Create a context for authentication
const FileUploadContext = createContext()

// Create a provider component
export const FileUploadProvider = ({ children }) => {
  const { authToken } = useAuth();
  const backendUrl = process.env.REACT_APP_BACKEND_URL
  const backendPort = process.env.REACT_APP_BACKEND_PORT

  let apiUrl = `${backendUrl}`

  if (backendPort) {
    apiUrl += `:${backendPort}`
  }

  const [files, setFiles] = useState([])
  const [isFetchingFiles, setIsFetchingFiles] = useState(false)

  const getAllFiles = async (params) => {
    try {
      setIsFetchingFiles(true)
      if (authToken) {
      const response = await axios.post(`${apiUrl}/api/get-all-files`, {
          token: authToken,
          params: params,
        });
        if (response.status === 200) {
          setFiles(response.data.result)
        } else {
          toast.error("Something went wrong.", {
            autoClose: 1000,
          });
        }
      }
    } catch (err) {
      //console.log('getAllFiles', err)
      // toast.error("Something went wrong.", {
      //   autoClose: 1000,
      // });
    } finally {
      setIsFetchingFiles(false)
    }
  };

  return (
    <FileUploadContext.Provider
      value={{ isFetchingFiles, setIsFetchingFiles, files, setFiles, getAllFiles }}
    >
      {children}
    </FileUploadContext.Provider>
  )
}

// Custom hook to access the authentication context
export const useFileUpload = () => useContext(FileUploadContext)
